



















import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({})
export default class MdcList extends Vue{
  @Prop({type:Boolean,default:false}) areaSelected!:boolean
  @Prop({type:Boolean,default:false}) activated!:boolean
  @Prop({type:Boolean,default:false}) selected!:boolean
  @Prop({default:undefined}) to?:string
  @Prop({default:'div'}) tag!:string
  @Prop({default:undefined}) icon?:string

  @Prop({type:Boolean,default:false}) activateOnLink!:boolean

  get is_():string{
    return this.to !== undefined ? 'router-link' : this.tag
  }
  get isActiveOnLink_(){
    if(!this.activateOnLink){
      return false
    }
    if(this.to === undefined){
      return false
    }
    const {route}=this.$router.resolve(this.to)
    return route.path === this.$route.path
  }
  get cssClass_(){
    return {
      'mdc-list-item--activated':this.activated || this.isActiveOnLink_,
      'mdc-list-item--selected':this.selected,
    }
  }
  hasSlot_(name:string):boolean{
    return this.$slots[name] !== undefined
  }
}
